import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Help Center Component
 * Embeds the HTML help portal within the React app
 * Supports deep linking to specific sections
 */
const HelpCenter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const iframeRef = useRef(null);

  useEffect(() => {
    // Extract section hash from URL (e.g., /help#incident-reporting)
    const hash = location.hash;

    // If there's a hash, navigate to that section in the iframe
    if (hash && iframeRef.current) {
      const section = hash.substring(1); // Remove the # symbol
      const helpUrl = `/help-portal/index.html#${section}`;
      iframeRef.current.src = helpUrl;
    }
  }, [location.hash]);

  return (
    <div className="help-center-container" style={{
      width: '100%',
      height: '100vh',
      overflow: 'hidden',
      margin: 0,
      padding: 0
    }}>
      <iframe
        ref={iframeRef}
        src="/help-portal/index.html"
        title="SAARV Help Center"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block'
        }}
        allow="fullscreen"
        loading="lazy"
      />
    </div>
  );
};

export default HelpCenter;
